import {
  Badge,
  Box,
  Button,
  Flex,
  Icon,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Skeleton,
  Switch,
  Text,
  useDisclosure,
  useTheme,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Nodata from "../../components/Nodata";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdDeleteForever,
  MdOutlineModeEdit,
  MdSearch,
} from "react-icons/md";
import StatusConfirmationModal from "../../components/StatusConfirmModal";
import Input from "../../components/CustomInput";
import { FaArrowRight } from "react-icons/fa";

const Summary = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const {
    isOpen: isDeletePeakHourOpen,
    onOpen: onDeletePeakHourOpen,
    onClose: onDeletePeakHourClose,
  } = useDisclosure();

  const {
    isOpen: isGlobalToggleOpen,
    onOpen: onGlobalToggleOpen,
    onClose: onGlobalToggleClose,
  } = useDisclosure();

  const {
    isOpen: isPayIncentiveOpen,
    onOpen: onPayIncentiveOpen,
    onClose: onPayIncentiveClose,
  } = useDisclosure();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [incentivePricing, setIncentivePricing] = React.useState<any>();

  const [searchMobile, setSearchMobile] = React.useState<any>("");

  const [enableGlobalIncentive, setEnableGlobalIncentive] =
    React.useState(false);
  const [enableDailyRides, setEnableDailyRides] = React.useState(false);
  const [enablePeakhours, setEnablePeakhours] = React.useState(false);
  const [enableFastPickup, setEnableFastPickup] = React.useState(false);

  const [isDataFetchingPeakHour, setIsDataFetchingPeakHour] =
    React.useState(true);

  const [allPeakHour, setAllPeakHour] = React.useState<any>([]);
  const [peakHourIdToDelete, setPeakHourIdToDelete] = React.useState<any>();

  const [summary, setSummary] = React.useState<any>();
  const [incentives, setIncentives] = React.useState<any>([]);

  const [incentiveId, setIncentiveId] = React.useState("");

  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("incentivepage")) || 1;
  });

  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);

  const getIncentives = async (page: number = 1) => {
    try {
      let url = `/incentives?page=${page}`;

      if (searchMobile.trim() !== "") {
        url += `&mobile=${encodeURIComponent(searchMobile.trim())}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      setSummary(res.data?.summary);
      setIncentives(res.data?.data);

      // If API returns less than your page size, disable next
      setNextNotAllowed(res.data?.data?.length === 0);
    } catch (error) {
      console.log("err", error);
    }
  };

  const getPeakHour = async (url: string) => {
    setIsDataFetchingPeakHour(true);
    try {
      const toggle = await axios.get("/incentives/toggle", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setEnableGlobalIncentive(toggle.data?.enabled);
      setEnableDailyRides(toggle.data?.daily_rides_enabled);
      setEnablePeakhours(toggle.data?.peak_hour_enabled);
      setEnableFastPickup(toggle.data?.fast_pickup_enabled);
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all drivers", res.data);
      const sortedData = [...res.data?.data].sort(
        (a, b) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
      );
      setAllPeakHour(sortedData);
    } catch (error) {
      console.log("error listing drivers", error);
    } finally {
      setIsDataFetchingPeakHour(false);
    }
  };

  const deletePeakHour = async () => {
    try {
      const res = await axios.delete(`/peak-hours/${peakHourIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("delete ", res.data);
      navigate(0);
    } catch (error) {
      console.log(error);
    }
  };

  const updateGlobalIncentiveToggle = async () => {
    try {
      const res = await axios.put(
        `/incentives/toggle`,
        {
          enabled: enableGlobalIncentive,
          daily_rides_enabled: enableDailyRides,
          peak_hour_enabled: enablePeakhours,
          fast_pickup_enabled: enableFastPickup,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        },
      );
      console.log("update ", res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditButtonClick = (val: string) => {
    navigate({
      pathname: "/incentives/edit",
      search: `?id=${val}`,
    });
  };

  const markIncentivePaid = async () => {
    try {
      const res = await axios.patch(`/incentives/${incentiveId}/paid`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("paid ", res.data);
      navigate(0);
    } catch (error) {
      console.log("err", error);
    }
  };

  const handleEditIncentivePricing = () => {
    navigate({
      pathname: "/incentives/update-pricing",
    });
  };

  const handleEditIncentiveTarget = () => {
    navigate({
      pathname: "/incentives/update-target",
    });
  };

  const handleViewIncentiveByDriverId = (val: string) => {
    navigate({
      pathname: "/incentives/view-by-driver",
      search: `?id=${val}`,
    });
  };

  const formatIncentiveType = (type: string) => {
    return type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getIncentivePricing = async () => {
    try {
      const res = await axios.get(`/incentives/amounts`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("res ", res.data);
      setIncentivePricing(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch peak hours only once
  React.useEffect(() => {
    getPeakHour("/peak-hours");
    getIncentivePricing();
  }, []);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      getIncentives(pageNumber);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchMobile, pageNumber]);

  return (
    <Box sx={{ padding: "1rem" }}>
      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        style={{
          width: "100%",
          margin: "1rem auto",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: "10px",
        }}
      >
        <Flex
          sx={{
            borderBottom: "1px solid",
            borderColor: theme.colors.divider,
            padding: "0.75rem 1.25rem",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
            Global Incentive Toggle
          </Text>
        </Flex>
        <Box
          sx={{
            padding: "1.25rem 0 1rem 1.25rem",
          }}
        >
          {/* Global Incentive */}
          <Flex
            sx={{
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Text
              sx={{
                fontSize: theme.fontSizes.caption,
                marginTop: theme.space.sm,
              }}
              color={theme.colors.secondary.light}
            >
              This enables incentive to the active peak hours
            </Text>

            <Switch
              isChecked={enableGlobalIncentive}
              colorScheme="red"
              size="sm"
              style={{ marginTop: "0.5rem" }}
              onChange={() => {
                const newValue = !enableGlobalIncentive;

                setEnableGlobalIncentive(newValue);

                // Disable all dependent incentives
                if (!newValue) {
                  setEnableDailyRides(false);
                  setEnablePeakhours(false);
                  setEnableFastPickup(false);
                }
              }}
            />
          </Flex>

          {/* Daily Rides */}
          <Flex
            sx={{
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Text
              sx={{
                fontSize: theme.fontSizes.caption,
                marginTop: theme.space.sm,
              }}
              color={
                enableGlobalIncentive
                  ? theme.colors.secondary.light
                  : theme.colors.secondary.light
              }
            >
              This enables daily rides
            </Text>

            <Switch
              isChecked={enableDailyRides}
              isDisabled={!enableGlobalIncentive}
              colorScheme="red"
              size="sm"
              style={{ marginTop: "0.5rem" }}
              onChange={() => {
                setEnableDailyRides(!enableDailyRides);
              }}
            />
          </Flex>

          {/* Peak Hours */}
          <Flex
            sx={{
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Text
              sx={{
                fontSize: theme.fontSizes.caption,
                marginTop: theme.space.sm,
              }}
              color={theme.colors.secondary.light}
            >
              This enables peak hours
            </Text>

            <Switch
              isChecked={enablePeakhours}
              isDisabled={!enableGlobalIncentive}
              colorScheme="red"
              size="sm"
              style={{ marginTop: "0.5rem" }}
              onChange={() => {
                setEnablePeakhours(!enablePeakhours);
              }}
            />
          </Flex>

          {/* Fast Pickup */}
          <Flex
            sx={{
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Text
              sx={{
                fontSize: theme.fontSizes.caption,
                marginTop: theme.space.sm,
              }}
              color={theme.colors.secondary.light}
            >
              This enables fast pickup
            </Text>

            <Switch
              isChecked={enableFastPickup}
              isDisabled={!enableGlobalIncentive}
              colorScheme="red"
              size="sm"
              style={{ marginTop: "0.5rem" }}
              onChange={() => {
                setEnableFastPickup(!enableFastPickup);
              }}
            />
          </Flex>

          <Box sx={{ marginTop: theme.space.xxl }}>
            <Button
              width="10rem"
              height="3rem"
              style={{
                background: theme.colors.primary.main,
                color: theme.colors.bg.main,
              }}
              onClick={() => {
                onGlobalToggleOpen();
              }}
            >
              <Text sx={{ fontSize: theme.fontSizes.body }}>Save Changes</Text>
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        style={{
          flex: 1,
          margin: "1rem auto",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          maxHeight: "max-content",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <Flex
          sx={{
            borderBottom: "1px solid",
            borderColor: theme.colors.divider,
            padding: "0.75rem 1.25rem",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Text sx={{ fontSize: "1.25rem", fontWeight: 900 }}>
              Created peak hours
            </Text>

            <Text
              sx={{
                fontSize: "0.8rem",
                color: "#888",
                marginTop: "0.15rem",
              }}
            >
              Manage your configured peak hour periods
            </Text>
          </Box>

          <Box
            sx={{
              padding: "0.35rem 0.75rem",
              borderRadius: "20px",
              background: "#F5F5F5",
            }}
          >
            <Text
              sx={{
                fontSize: "0.8rem",
                fontWeight: 600,
                color: "#555",
              }}
            >
              {allPeakHour?.length || 0} Records
            </Text>
          </Box>
        </Flex>

        {/* Content */}
        <Box sx={{ padding: "1rem" }}>
          <Skeleton isLoaded={!isDataFetchingPeakHour} minHeight={"20rem"}>
            {allPeakHour && allPeakHour.length !== 0 ? (
              <table
                style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "left",
                        padding: "0.75rem 1rem",
                        background: "#F8F8F8",
                        borderBottom: `1px solid ${theme.colors.divider}`,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        Start time
                      </Text>
                    </th>

                    <th
                      style={{
                        textAlign: "left",
                        padding: "0.75rem 1rem",
                        background: "#F8F8F8",
                        borderBottom: `1px solid ${theme.colors.divider}`,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        End time
                      </Text>
                    </th>

                    <th
                      style={{
                        textAlign: "center",
                        padding: "0.75rem 1rem",
                        background: "#F8F8F8",
                        borderBottom: `1px solid ${theme.colors.divider}`,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        Status
                      </Text>
                    </th>

                    <th
                      style={{
                        textAlign: "center",
                        padding: "0.75rem 1rem",
                        background: "#F8F8F8",
                        borderBottom: `1px solid ${theme.colors.divider}`,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        Edit
                      </Text>
                    </th>

                    <th
                      style={{
                        textAlign: "center",
                        padding: "0.75rem 1rem",
                        background: "#F8F8F8",
                        borderBottom: `1px solid ${theme.colors.divider}`,
                      }}
                    >
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading1,
                        }}
                      >
                        Delete
                      </Text>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {allPeakHour.map((item: any) => (
                    <tr key={item.id}>
                      {/* Start time */}
                      <td
                        style={{
                          padding: "0.9rem 1rem",
                          borderBottom: `1px solid ${theme.colors.divider}`,
                        }}
                      >
                        <Text
                          sx={{
                            fontSize: theme.fontSizes.subHeading2,
                            fontWeight: 600,
                          }}
                        >
                          {item.start_time}
                        </Text>
                      </td>

                      {/* End time */}
                      <td
                        style={{
                          padding: "0.9rem 1rem",
                          borderBottom: `1px solid ${theme.colors.divider}`,
                        }}
                      >
                        <Text
                          sx={{
                            fontSize: theme.fontSizes.subHeading2,
                            fontWeight: 600,
                          }}
                        >
                          {item.end_time}
                        </Text>
                      </td>

                      {/* Status */}
                      <td
                        style={{
                          padding: "0.9rem 1rem",
                          borderBottom: `1px solid ${theme.colors.divider}`,
                        }}
                      >
                        <Flex justifyContent="center">
                          <Flex
                            justifyContent="center"
                            alignItems="center"
                            minWidth="5.5rem"
                            padding="0.35rem 0.75rem"
                            background={
                              item?.status === "active"
                                ? theme.colors.success
                                : theme.colors.error
                            }
                            borderRadius="20px"
                          >
                            <Text
                              sx={{
                                fontSize: "0.8rem",
                                color: "#FFFFFF",
                                fontWeight: 600,
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.status}
                            </Text>
                          </Flex>
                        </Flex>
                      </td>

                      {/* Edit */}
                      <td
                        style={{
                          padding: "0.9rem 1rem",
                          borderBottom: `1px solid ${theme.colors.divider}`,
                        }}
                      >
                        <Flex
                          justifyContent="center"
                          alignItems="center"
                          cursor="pointer"
                        >
                          <Icon
                            as={MdOutlineModeEdit}
                            width={5}
                            height={5}
                            color={theme.colors.primary.main}
                            cursor="pointer"
                            onClick={() => handleEditButtonClick(item?.id)}
                          />
                        </Flex>
                      </td>

                      {/* Delete */}
                      <td
                        style={{
                          padding: "0.9rem 1rem",
                          borderBottom: `1px solid ${theme.colors.divider}`,
                        }}
                      >
                        <Flex
                          justifyContent="center"
                          alignItems="center"
                          cursor="pointer"
                          onClick={() => {
                            onDeletePeakHourOpen();
                            setPeakHourIdToDelete(item.id);
                          }}
                        >
                          <Icon
                            as={MdDeleteForever}
                            width={5}
                            height={5}
                            color={theme.colors.primary.main}
                            cursor="pointer"
                          />
                        </Flex>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <Box>
                <Nodata heading="No Peak hour created" />
              </Box>
            )}
          </Skeleton>

          <StatusConfirmationModal
            heading="Are you sure want to this peak hour ?"
            isOpen={isDeletePeakHourOpen}
            onClose={onDeletePeakHourClose}
            handleApiCall={() => deletePeakHour()}
          />

          <StatusConfirmationModal
            heading="Are you sure want to change this settings?"
            isOpen={isGlobalToggleOpen}
            onClose={() => {
              onGlobalToggleClose();
            }}
            handleApiCall={() => updateGlobalIncentiveToggle()}
          />
        </Box>
      </Box>

      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        overflow="hidden"
        marginTop="1rem"
      >
        {/* Header */}
        <Flex
          px={5}
          py={4}
          borderBottom="1px solid"
          borderColor="gray.200"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box>
            <Text fontSize="18px" fontWeight="700">
              Incentive Payout Amount
            </Text>

            <Text mt={1} fontSize="13px" color="gray.500">
              Configure the amount for each incentive type
            </Text>
          </Box>

          <Flex justifyContent="center" alignItems="center" gap={"2rem"}>
            <Badge
              px={3}
              py={1}
              borderRadius="20px"
              colorScheme={incentivePricing?.enabled ? "green" : "red"}
            >
              {incentivePricing?.enabled ? "Enabled" : "Disabled"}
            </Badge>

            <Flex
              alignItems={"center"}
              gap={"0.5rem"}
              cursor="pointer"
              onClick={() => handleEditIncentivePricing()}
            >
              <Icon
                as={MdOutlineModeEdit}
                width={5}
                height={5}
                color={theme.colors.primary.main}
              />
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                }}
              >
                Update Payout
              </Text>
            </Flex>

            <Flex
              alignItems={"center"}
              gap={"0.5rem"}
              cursor="pointer"
              onClick={() => handleEditIncentiveTarget()}
            >
              <Icon
                as={MdOutlineModeEdit}
                width={5}
                height={5}
                color={theme.colors.primary.main}
              />
              <Text
                sx={{
                  fontSize: "1rem",
                  fontWeight: 900,
                  color: theme.colors.primary.main,
                }}
              >
                Update Target
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* Pricing Cards */}
        <Box p={5}>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
            {/* Daily Rides */}
            <Box
              p={5}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="10px"
              bg="gray.50"
            >
              <Text fontSize="13px" color="gray.500" fontWeight="500">
                Daily Rides Incentive
              </Text>

              <Text
                mt={2}
                fontSize="28px"
                fontWeight="700"
                color={theme.colors.primary.main}
              >
                ₹{incentivePricing?.incentive_daily_rides_amount ?? 0}
              </Text>

              <Text mt={1} fontSize="12px" color="gray.500">
                Reward after completing daily{" "}
                {incentivePricing?.daily_rides_target} rides
              </Text>
            </Box>

            {/* Fast Pickup */}
            <Box
              p={5}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="10px"
              bg="gray.50"
            >
              <Text fontSize="13px" color="gray.500" fontWeight="500">
                Fast Pickup Incentive
              </Text>

              <Text
                mt={2}
                fontSize="28px"
                fontWeight="700"
                color={theme.colors.primary.main}
              >
                ₹{incentivePricing?.incentive_fast_pickup_amount ?? 0}
              </Text>

              <Text mt={1} fontSize="12px" color="gray.500">
                Reward for fast pickup in{" "}
                {incentivePricing?.fast_pickup_minutes} minutes and{" "}
                {incentivePricing?.fast_pickup_daily_cap} rides daily
              </Text>
            </Box>

            {/* Peak Hour */}
            <Box
              p={5}
              border="1px solid"
              borderColor="gray.200"
              borderRadius="10px"
              bg="gray.50"
            >
              <Text fontSize="13px" color="gray.500" fontWeight="500">
                Peak Hour
              </Text>

              <Text
                mt={2}
                fontSize="28px"
                fontWeight="700"
                color={theme.colors.primary.main}
              >
                ₹{incentivePricing?.incentive_peak_hour_amount ?? 0}
              </Text>

              <Text mt={1} fontSize="12px" color="gray.500">
                Reward during peak hours completing{" "}
                {incentivePricing?.peak_hour_rides_target} rides
              </Text>
            </Box>
          </SimpleGrid>

          {/* Last Updated */}
          {incentivePricing?.updated_at && (
            <Flex mt={4} justifyContent="flex-end" alignItems="center">
              <Text fontSize="12px" color="gray.400">
                Last updated:{" "}
                {new Date(incentivePricing.updated_at).toLocaleString()}
              </Text>
            </Flex>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          height: "100%",
          maxWidth: "20rem",
          marginBottom: "1rem",
          marginTop: "2rem",
        }}
      >
        <InputGroup>
          <InputRightElement h="100%" cursor={"pointer"}>
            <MdSearch color={theme.colors.secondary.main} size={20} />
          </InputRightElement>
          <Input
            variant={"outline"}
            placeholder="Search driver by mobile number"
            sx={{
              height: "100%",
            }}
            borderColor={theme.colors.secondary.main}
            onChange={(e) => {
              setSearchMobile(e.target.value);
              setPageNumber(1);
              localStorage.setItem("incentivepage", "1");
            }}
          />
        </InputGroup>
      </Box>

      {searchMobile.trim() !== "" && (
        <Box
          mb="1rem"
          px="1rem"
          py="0.75rem"
          borderRadius="8px"
          background="#FFF8F8"
          border="1px solid"
          borderColor={theme.colors.divider}
        >
          <Text fontSize="0.85rem" color={theme.colors.secondary.main}>
            <Text as="span" fontWeight={700}>
              Driver-specific view:
            </Text>{" "}
            The summary and incentive records displayed below belong to the
            driver matching the searched mobile number.
          </Text>
        </Box>
      )}

      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        overflow="hidden"
      >
        <Box px={5} py={4} borderBottom="1px solid" borderColor="gray.200">
          <Text fontSize="18px" fontWeight="700">
            Incentive Summary
          </Text>
        </Box>

        <Box p={5}>
          {/* Main summary cards */}
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4}>
            <Box
              p={4}
              borderRadius="8px"
              bg="gray.50"
              border="1px solid"
              borderColor="gray.100"
            >
              <Text fontSize="13px" color="gray.500">
                Total Incentives
              </Text>

              <Text mt={1} fontSize="24px" fontWeight="700">
                ₹{summary?.total_amount || 0}
              </Text>

              <Text fontSize="12px" color="gray.500">
                {summary?.total_count || 0} incentives
              </Text>
            </Box>

            <Box
              p={4}
              borderRadius="8px"
              bg="red.50"
              border="1px solid"
              borderColor="red.100"
            >
              <Text fontSize="13px" color="gray.500">
                Unpaid Amount
              </Text>

              <Text mt={1} fontSize="24px" fontWeight="700" color="red.600">
                ₹{summary?.unpaid_amount || 0}
              </Text>

              <Text fontSize="12px" color="gray.500">
                {summary?.unpaid_count || 0} unpaid
              </Text>
            </Box>

            <Box
              p={4}
              borderRadius="8px"
              bg="green.50"
              border="1px solid"
              borderColor="green.100"
            >
              <Text fontSize="13px" color="gray.500">
                Paid Amount
              </Text>

              <Text mt={1} fontSize="24px" fontWeight="700" color="green.600">
                ₹{(summary?.total_amount || 0) - (summary?.unpaid_amount || 0)}
              </Text>

              <Text fontSize="12px" color="gray.500">
                {summary?.total_count - summary?.unpaid_count || 0} paid
              </Text>
            </Box>

            <Box
              p={4}
              borderRadius="8px"
              bg="purple.50"
              border="1px solid"
              borderColor="purple.100"
            >
              <Text fontSize="13px" color="gray.500">
                Incentive Types
              </Text>

              <Text mt={1} fontSize="24px" fontWeight="700" color="purple.600">
                {Object.keys(summary?.by_type || {}).length}
              </Text>

              <Text fontSize="12px" color="gray.500">
                Active incentive categories
              </Text>
            </Box>
          </SimpleGrid>

          {/* Breakdown */}
          <Box mt={6}>
            <Text mb={3} fontSize="15px" fontWeight="600">
              Breakdown by Type
            </Text>

            <Box
              border="1px solid"
              borderColor="gray.200"
              borderRadius="8px"
              overflow="hidden"
            >
              <Flex
                px={4}
                py={3}
                bg="gray.50"
                borderBottom="1px solid"
                borderColor="gray.200"
                fontSize="13px"
                fontWeight="600"
                color="gray.600"
              >
                <Box flex={2}>Incentive Type</Box>
                <Box flex={1}>Count</Box>
                <Box flex={1}>Amount</Box>
                <Box flex={1}>Unpaid</Box>
              </Flex>

              {Object.entries(summary?.by_type || {}).map(
                ([type, item]: [string, any]) => (
                  <Flex
                    key={type}
                    px={4}
                    py={3}
                    alignItems="center"
                    borderBottom="1px solid"
                    borderColor="gray.100"
                    fontSize="14px"
                    _last={{ borderBottom: "none" }}
                  >
                    <Box flex={2}>
                      <Text fontWeight="500">{formatIncentiveType(type)}</Text>
                    </Box>

                    <Box flex={1}>
                      <Text>{item.count}</Text>
                    </Box>

                    <Box flex={1}>
                      <Text fontWeight="600">₹{item.amount}</Text>
                    </Box>

                    <Box flex={1}>
                      <Text color="red.600" fontWeight="500">
                        ₹{item.unpaid_amount}
                      </Text>
                    </Box>
                  </Flex>
                ),
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        bg="white"
        borderRadius="10px"
        border="1px solid"
        borderColor="gray.200"
        overflow="hidden"
        marginTop={"1rem"}
      >
        <Box px={5} py={4} borderBottom="1px solid" borderColor="gray.200">
          <Flex justifyContent="space-between" alignItems="center">
            <Box>
              <Text fontSize="18px" fontWeight="700">
                Incentives payable to drivers
              </Text>

              <Text mt={1} fontSize="13px" color="gray.500">
                Incentive earnings generated from completed rides
              </Text>
            </Box>

            <Box
              px={3}
              py={1}
              borderRadius="20px"
              bg="gray.100"
              fontSize="13px"
              fontWeight="600"
            >
              {incentives?.length || 0} Records
            </Box>
          </Flex>
        </Box>

        <Box p={4}>
          {/* Header */}
          <Flex
            px={4}
            py={3}
            bg="gray.50"
            borderRadius="7px"
            fontSize="12px"
            fontWeight="600"
            color="gray.500"
            textTransform="uppercase"
          >
            <Box flex={2}>Driver</Box>
            <Box flex={1}>Total</Box>
            <Box flex={1}>Incentives</Box>
            <Box flex={1.2}>Unpaid</Box>
            <Box flex={0.8}>View</Box>
          </Flex>

          {/* Data */}
          <Box mt={1}>
            {incentives?.map((item: any) => (
              <Flex
                key={item.driver_id}
                px={4}
                py={4}
                alignItems="center"
                borderBottom="1px solid"
                borderColor="gray.100"
                fontSize="14px"
                _last={{ borderBottom: "none" }}
                _hover={{
                  bg: "gray.50",
                }}
                transition="0.2s"
              >
                {/* Driver */}
                <Box flex={2}>
                  <Text fontWeight="600">{item?.driver?.name}</Text>

                  <Text
                    mt={1}
                    fontSize="12px"
                    color="gray.400"
                    noOfLines={1}
                    title={item.driver?.mobile}
                  >
                    {item.driver?.mobile}
                  </Text>
                </Box>

                {/* Total Amount */}
                <Box flex={1}>
                  <Text fontSize="15px" fontWeight="700">
                    ₹{item.total_amount}
                  </Text>

                  <Text mt={1} fontSize="11px" color="gray.400">
                    {item.total_count} incentives
                  </Text>
                </Box>

                {/* Incentive Count */}
                <Box flex={1}>
                  <Badge
                    px={3}
                    py={1}
                    borderRadius="20px"
                    colorScheme="blue"
                    fontSize="11px"
                  >
                    {item.total_count}
                  </Badge>
                </Box>

                {/* Unpaid */}
                <Box flex={1.2}>
                  <Text fontSize="14px" fontWeight="700" color="orange.500">
                    ₹{item.unpaid_amount}
                  </Text>

                  <Text mt={1} fontSize="11px" color="gray.400">
                    {item.unpaid_count} unpaid
                  </Text>
                </Box>

                {/* View */}
                <Box flex={0.8}>
                  <Icon
                    as={FaArrowRight}
                    width={5}
                    height={5}
                    color={theme.colors.primary.main}
                    cursor="pointer"
                    onClick={() =>
                      handleViewIncentiveByDriverId(item.driver_id)
                    }
                  />
                </Box>
              </Flex>
            ))}
            <StatusConfirmationModal
              heading="Are you sure incentive is paid ?"
              isOpen={isPayIncentiveOpen}
              onClose={onPayIncentiveClose}
              handleApiCall={() => markIncentivePaid()}
            />
          </Box>

          <Box
            sx={{
              marginTop: theme.space.xl,
            }}
          >
            <Flex
              sx={{
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "3rem",
              }}
            >
              <Box>
                <Flex
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Flex
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      width: "2rem",
                      height: "2rem",
                    }}
                  >
                    <Icon
                      as={MdArrowBackIosNew}
                      boxSize={5}
                      color={theme.colors.primary.main}
                      cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                      onClick={() => {
                        if (pageNumber !== 1) {
                          setPageNumber(pageNumber - 1);
                          localStorage.setItem(
                            "incentivepage",
                            `${pageNumber - 1}`,
                          );
                        }
                      }}
                    />
                  </Flex>
                  <Text variant={"caption"}>Previous Page</Text>
                </Flex>
              </Box>
              <Skeleton
                isLoaded={isDataFetchingPeakHour ? false : true}
                sx={{ width: "2rem" }}
              >
                <Text variant={"body"}>{pageNumber}</Text>
              </Skeleton>
              <Box>
                <Flex
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Text variant={"caption"}>Next Page</Text>
                  <Flex
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "50%",
                      width: "2rem",
                      height: "2rem",
                    }}
                  >
                    <Icon
                      as={MdArrowForwardIos}
                      boxSize={5}
                      color={theme.colors.primary.main}
                      cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                      onClick={() => {
                        if (!nextNotAllowed) {
                          setPageNumber(pageNumber + 1);
                          localStorage.setItem(
                            "incentivepage",
                            `${pageNumber + 1}`,
                          );
                        }
                      }}
                    />
                  </Flex>
                </Flex>
              </Box>
            </Flex>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Summary;
